( function ( $ ) {
	var $scrollIn = $(".wp-block-indy-teaser, .wp-block-indy-teaser-large, .wp-block-indy-teaser-slider," +
		" .wp-block-indy-woo-product-category .product, .wp-block-indy-testimonials," +
		" .wp-block-indy-page-header, .b2b, #footer");

	var $scrollBottom = $(".wp-block-indy-teaser .body__text, .wp-block-indy-teaser-large .container .col," +
		" .wp-block-indy-teaser-slider .container .col , .b2b .container, .card-body__image, .card-body__content," +
		" .wp-block-indy-woo-product-category .product .product-details-wrapper, .article-header," +
		" .wp-block-indy-woo-product-category .category__info .row, .wp-block-indy-page-header .container," +
		" .wp-block-indy-page-title .row");

	$(document).ready(function () {
		animate();
	});

	$(document).scroll(function () {
		animate();
	});

	$('.offcanvas a.nav-link').click(function () {
		animate();
	});

	function animate(){
		$scrollIn.each(function(){
				$(this).addClass("not-scrolled");
		})
		$scrollBottom.each(function(){
			$(this).addClass("not-scrolled");
		})
		$scrollIn.each(function(){
			if($(this).offset().top <= $(window).scrollTop()+$(window).height()-65 && $(this).hasClass("not-scrolled")){
				$(this).removeClass("not-scrolled");
				$(this).addClass("fade-in");
			}
		});
		$scrollBottom.each(function(){
			if($(this).offset().top <= $(window).scrollTop()+$(window).height()-65 && $(this).hasClass("not-scrolled")){
				$(this).removeClass("not-scrolled");
				$(this).addClass("fade-bottom");
			}
		});
	}

} )( jQuery );
